import React from 'react';

const Footer = () =>{
        return(
            <div>
                <footer>
                    <div className=' text-center'> 
                        
                        <p>Created with <i className="fas fa-heart"></i> by Robert Sarpong &copy; </p>
                    </div>
                </footer>
            </div>
        )
}

export default Footer;